import { Check, Layer } from "../../../Layers/constants";
import { RootConfigType } from "../constantsTyped";
import { onload_layer_callbacks_mission_us } from "./mission_us";

export interface OnloadLayerCallbackProps {
    layer: Layer;
    checks: Check[];
    patchLayer: (field: string, value: any, callApi?: boolean) => void;
    config: RootConfigType;
}

export const onload_layer_callbacks = {
    onload_layer_callbacks_mission_us
};
